import React, { useState, useEffect } from 'react'

import File from '../../assets/img/file@2x.png'
import UploadFile from '../UploadSingleFile/upload.component'
import { deleteMedia } from '../../api/upload'
import UploadSingleFileCommande from '../UploadSingleFile/UploadSingleFileCommande'
import { useTranslation } from 'react-i18next'

function UploadFileCommande({ name, onChange, initialFiles = [] }) {
	const [files, setFiles] = useState(initialFiles)
	const [resetUploader, setResetUploader] = useState(0)

	const [disabled, setDisabled] = useState(files.length >= 5)
	useEffect(() => {
		setDisabled(files.length >= 5)
	}, [files])
    const {t} = useTranslation();
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	
		useEffect(() => {
			const checkScreen = () => {
				const width = window.innerWidth;
	
				setIsMobile(width < 768);
	
			};
			checkScreen();
			window.addEventListener('resize', checkScreen);
	
			return () => window.removeEventListener('resize', checkScreen);
		}, []);
	return (
		<div>
			<UploadSingleFileCommande
				key={resetUploader}
				name={name}
				disabled={disabled}
				accept=' .pdf'
				onFile={(file) => {
					setFiles([...files, file])
					onChange([...files, file])
				}}
			/>

			{files.map((file, index) => (
				<div
					style={{
						marginBottom: '1rem',
					}}
					key={index}
				>
					<div
						key={String(index)}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'flex-start',
							marginBottom: 20,
						}}
					>
						<img
							src={File}
							style={{
								height: 20,
								marginRight: '1rem',
							}}
							alt=''
						/>
						<span
							style={{
								marginRight: '1rem',
								width: isMobile? '100%' :'10rem',
							}}
						>
							{file?.name}
						</span>
					</div>
					<button
						onClick={async (e) => {
							e.preventDefault()
							await deleteMedia(file.id)
							setFiles(files.filter((f) => f.name !== file.name))
							onChange(files.filter((f) => f.name !== file.name))
							setResetUploader((prev) => prev + 1)
						}}
						style={{
							color: 'white',
							border: 'none',
							backgroundColor: '#51C7F2',
							padding: '0.5rem 1rem',
							fontFamily: 'Montserrat',
							borderRadius: '0.5rem',
							cursor: 'pointer',
						}}
					>
						{t("delete")}
					</button>
				</div>
			))}
		</div>
	)
}

export default React.memo(UploadFileCommande)
